import axios from 'axios';

// The ticket « Résumé » (28/10): generated on demand, stored on the ticket by
// the backend, in the language the person chose in « Affichage ». Read the
// stored one first; generate only when there is none or on « Régénérer ».

const authHeaders = () => {
  const token = localStorage.getItem('access_token');
  return { headers: token ? { Authorization: `Bearer ${token}` } : {} };
};

// { summary, language, preferred_language, language_matches, generated_at,
//   generated_by, stale } — `summary` is null when none was generated yet.
export const fetchStoredSummary = async (ticketId) => {
  const response = await axios.get(`/api/tickets/${ticketId}/conversation-summary`, authHeaders());
  return response.data || { summary: null };
};

// Generates (and stores) a new summary; same shape as fetchStoredSummary.
export const generateSummary = async (ticketId) => {
  const response = await axios.post('/api/messages/summary', { ticket_id: ticketId }, authHeaders());
  const data = response.data || {};
  return data.conversation_summary || { summary: data.summary || null };
};

// A stored summary is shown as is when it is current and in the person's
// language; otherwise it is shown with a note and « Mettre à jour ».
export const summaryNeedsUpdate = (data) => Boolean(
  data && data.summary && (data.stale || data.language_matches === false)
);
